module.exports = __webpack_public_path__ + "img/92184.94430a6c.svg";